import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCf5: [],
		cf5: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {},
	mutations: {
		set(state, cf5) {
			state.cf5 = cf5
			if (cf5) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cf5 = null
		},
		setParamsDataTable(state, payload) {
			state.lstCf5 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		}
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, cf5tipo) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Customer/CustomerType/Find/${cf5tipo}`)
				.then(response => {
					let cf5 = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cf5)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			store.state.loading = false
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.post("/Customer/CustomerType/Insert", store.state.cf5)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/tipos-de-cliente")
					store.state.cf5 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.put("/Customer/CustomerType/Update", store.state.cf5)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/tipos-de-cliente")
					store.state.cf5 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.delete(`/Customer/CustomerType/Delete/${store.state.cf5.cf5tipo}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/tipos-de-cliente")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get("/Customer/CustomerType/FindList")
				.then(response => {
					let lstCf5 = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCf5 = lstCf5
					store.state.hasNext = lstCf5.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCf5 = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Customer/CustomerType/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCf5 = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
			return payload
		}
	}
}
